import { action,observable,computed,toJS } from 'mobx'
import T from 'i18n-react'
import route from './fetchconfig.json'

export default class NewCollectionFormStore {

 @observable exampleids
 @observable title = ""
 @observable description = ""
 @observable contact

 injectCollection (collection) {
   const { id,title,description,exampleids,contact} = collection
   this.id = id
   this.title = title ? title : ""
   this.description = description ? description : ""
   this.contact = contact ? contact : ""
   if (exampleids) {
     if (exampleids instanceof Array) this.exampleids = exampleids
     if (typeof exampleids == 'string') this.exampleids = exampleids.split(',')
   } else this.exampleids = []
 }

 @action.bound clear () {
   this.title = ""
   this.description = ""
   this.contact = ""
 }

 @computed get canBeSuggestedForPublish () {
   return this.title !== "" && this.description !== ""
 }

 @action.bound setTitle (title) {
   this.title = title
 }

 @action.bound setDescription (description) {
   this.description = description
 }

 @action.bound setExampleids (exampleids) {
   this.exampleids = exampleids
 }

 @action.bound setContact (contact) {
   this.contact = contact
 }

 @computed get relativeCollectionLink () {
   return route.endpoint + '/collection?s=' + this.exampleids.map(id => id).join()
 }

 getPayload () {
   return {
     id:this.id,
     title:this.title,
     description:this.description,
     exampleids:this.exampleids,
     contact:this.contact
   }
 }

}



// WEBPACK FOOTER //
// ./src/stores/newcollectionform.js